<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>noise_control_off</mat-icon>
        <div>Próximos Eventos</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon class="icon-add">add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>


  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="position" matSortDirection='asc'
      matSortDisableClear=true style='height: calc(100vh - 180px); overflow: auto;'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="icon-dot">noise_control_off</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Image Column -->
      <ng-container matColumnDef="image">
        <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img style="width: 150px; margin: 10px;" [src]=element.src>
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>



      <!-- dateIn/dateOut Column -->
      <ng-container matColumnDef="dateIn">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Entrada/Saida </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <div>
              {{ element.dateIn.seconds*1000 | date: "dd/MM/yyyy" }}
            </div>
            <div>
              {{ element.dateOut.seconds*1000 | date: "dd/MM/yyyy" }}
            </div>
          </div>

        </mat-cell>
      </ng-container>
      ]
      <!-- dateOut Column -->
      <ng-container matColumnDef="dateStart">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Início/Término </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <div>
              {{ element.dateStart.seconds*1000 | date: "dd/MM/yyyy" }}
            </div>
            <div>
              {{ element.dateEnd.seconds*1000 | date: "dd/MM/yyyy" }}
            </div>
          </div>
        </mat-cell>
      </ng-container>


      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' matTooltip='Editar' style="background-color: whitesmoke;">
            <mat-icon class='icon-info'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>